import { render, staticRenderFns } from "./recordComments.vue?vue&type=template&id=57d798a5&"
import script from "./recordComments.vue?vue&type=script&lang=js&"
export * from "./recordComments.vue?vue&type=script&lang=js&"
import style0 from "./recordComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports